<!-- A mailto link whose address is put together only in the browser (kept from scrapers). Its
     text is the address, or whatever it wraps (2026-10-14: e.g. a whole button). -->
<template>
  <a :href="`mailto:${email}`"><slot>{{ email }}</slot></a>
</template>

<script setup>
import {ref, onMounted} from "vue";
const props = defineProps({
  recipient: {type: String, default: ""},
  domain: {type: String, default: ""}
});
const email = ref(""); // holds assembled email address
const assembleEmail = () => {
  email.value = `${props.recipient}@${props.domain}`;
};
onMounted(assembleEmail); // Assemble email address when component mounted
</script>
